import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import classNames from 'classnames';
import { AmplienceImage } from 'components/amplience/types';
import { imageAmplienceToUrl } from 'helpers/utils/amplience/imageAmplienceToUrl';
import { amplienceImageLoader } from 'helpers/utils/amplience/imageLoader';
import { gtmMenuNavigation } from 'helpers/utils/gtm-events/gtmInteraction';
import ForwardIcon from 'icons/forward';
import { layout } from 'static/constants';
import { AmplienceNavColumnProps } from '.';

export interface AmplienceNavColumnMobileProps extends AmplienceNavColumnProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  showImages?: boolean;
}
const AmplienceNavColumnMobile: FC<AmplienceNavColumnMobileProps> = ({
  mainTitle,
  rows,
  isOpen,
  onClick,
  mainLink,
  className,
  showImages = false,
}) => {
  const hasExpandableRows = rows?.some((row) => row.title || (showImages && row.image && row.image.length > 0));

  return (
    <li className={className + ' flex w-full flex-col items-center justify-between border-b p-5'}>
      <div className="flex w-full items-center justify-between">
        {mainLink ? (
          <Link
            onClick={() => {
              gtmMenuNavigation({ click_location: 'header', click_name: mainTitle });
            }}
            href={mainLink || ''}
            className="flex shrink-0 text-sm font-semibold leading-[17px] text-[#222222]"
            aria-label={mainTitle}
          >
            {mainTitle}
          </Link>
        ) : (
          <div className="flex shrink-0 text-sm font-semibold leading-[17px] text-[#222222]">{mainTitle}</div>
        )}
        {hasExpandableRows && (
          <button
            data-testid={`nav-group-arrow-${mainTitle}`}
            onClick={onClick}
            className="flex w-fit grow justify-end p-0"
            aria-label={`${mainTitle}`}
          >
            <ForwardIcon className={classNames({ 'rotate-90': !isOpen, '-rotate-90': isOpen })} />
          </button>
        )}
      </div>
      {hasExpandableRows && isOpen && (
        <ul className="mt-4 flex w-full flex-col font-light">
          {rows?.map((row, index) => {
            return (
              <li key={`nav-column-mobile-${mainTitle}-${row.title}-${index}`} className="py-1">
                <Link
                  onClick={() => {
                    gtmMenuNavigation({ click_location: 'header', click_name: row.title });
                  }}
                  className="inline-block w-full text-[13px] font-normal leading-[19px] text-[#222222] hover:underline"
                  href={row.link || ''}
                  aria-label={row.title}
                >
                  {row.title}

                  {showImages && row.image && row.image?.length > 0 && row.image?.[0].image && (
                    <span className="relative h-[175px] w-full">
                      <Image
                        loader={() =>
                          amplienceImageLoader({
                            src: imageAmplienceToUrl(row.image?.[0].image as AmplienceImage),
                            width: 200,
                          })
                        }
                        height={175}
                        width={200}
                        src={imageAmplienceToUrl(row.image[0].image)}
                        sizes={`(max-width: 1023px) 50vw, ${layout.pageMaxWidth}px`}
                        alt={row.image[0].altImage || 'Alt text'}
                        loading="eager"
                      />
                    </span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default AmplienceNavColumnMobile;
